import React, { useState } from "react"
import { useRouter } from "next/router"
import { Swiper, SwiperSlide } from "swiper/react"
import { Pagination, A11y, Autoplay, Controller } from "swiper/modules"
import "swiper/css"
import "swiper/css/pagination"

/**
 * @typedef {Object} SectionItem
 * @property {string} title
 * @property {string} img
 * @property {string|null} link
 */
/**
 * @typedef {Object} Section
 * @property {string} title
 * @property {SectionItem[]} items
 */

/** @type {Section[]} */

const ShoppingGuideImage = ({ shoppingGuideImageData = {} }) => {
  const { horizontalRule = true } = shoppingGuideImageData
  const router = useRouter()
  const locale = router.locale
  const [controlledSwiper, setControlledSwiper] = useState(null)
  return (
    <div
      className=" pt-5
          w-full
          max-w-full              /* 0–767px: no max-width cap */
          mx-auto
          space-y-14
          overflow-x-hidden       /* prevent any accidental horizontal scroll */
           px-[20px]
min-[1100px]:px-[calc((100%-980px)/2)]
    "
    >
      <div className="py-0 md:px-0 min-[1100px]:px-[138px]">
        {/* Section Title */}
        {shoppingGuideImageData?.title && (
          <h2 className="text-3xl leading-[1.1] text-black mb-10 font-[Helvetica-Light,Helvetica,sans-serif]">
            {shoppingGuideImageData?.title}
          </h2>
        )}

        {/* Mobile: Swiper carousel */}
        <div className="md:hidden -mx-4 px-[20px]">
          <Swiper
            modules={[Pagination, A11y, Autoplay, Controller]}
            slidesPerView={1}
            onSwiper={setControlledSwiper}
            controller={{ control: controlledSwiper }}
            spaceBetween={16}
            pagination={{ clickable: true }}
            autoplay={{
              delay: 3000,
              disableOnInteraction: false,
              pauseOnMouseEnter: false,
            }} // auto swipe
            className="           
                  px-4
                  [&_.swiper-pagination]:mt-[18px]
                  /* If you want them below normally-flowing content */
                  /* [&_.swiper-pagination]:!static */

                  /* Or keep them overlayed but push further down */
                  /* [&_.swiper-pagination]:absolute [&_.swiper-pagination]:left-1/2
                    [&_.swiper-pagination]:bottom-3 md:[&_.swiper-pagination]:bottom-4 */

                  /* --- Only active dot black --- */
                      [--swiper-pagination-color:#000]                    /* active: black */
                      [--swiper-pagination-bullet-inactive-color:#9ca3af] /* inactive: gray-400 */
                      [--swiper-pagination-bullet-inactive-opacity:1]     /* fully visible */

                      [--swiper-pagination-bullet-inactive-color:transparent]
                  [--swiper-pagination-bullet-inactive-opacity:1]
                  [&_.swiper-pagination-bullet:not(.swiper-pagination-bullet-active)]:border
                  [&_.swiper-pagination-bullet:not(.swiper-pagination-bullet-active)]:border-solid
                  [&_.swiper-pagination-bullet:not(.swiper-pagination-bullet-active)]:border-black

                  /* optional: size + gap */
                      [--swiper-pagination-bullet-size:12px]
                      [--swiper-pagination-bullet-horizontal-gap:8px]
                       [&_.swiper-pagination-bullet-active]:!w-[15px]
                  [&_.swiper-pagination-bullet-active]:!h-[15px]"
          >
            {shoppingGuideImageData?.cards?.map((item, i) => {
              const Wrapper = item?.fields?.linkUrl ? "a" : "div"
              return (
                item?.fields?.imageUrl && (
                  <SwiperSlide key={item?.fields?.title}>
                    <div className="space-y-3">
                      <div className="overflow-hidden bg-gray-100 rounded-md aspect-auto md:aspect-[4/3]">
                        <Wrapper
                          className={`block ${item?.fields?.linkUrl ? "cursor-pointer" : "cursor-default"}`}
                          href={
                            item?.fields?.linkUrl
                              ? `/${locale}${item.fields.linkUrl}`
                              : undefined
                          }
                        >
                          <img
                            src={item?.fields?.imageUrl}
                            alt={item?.fields?.title}
                            className="w-full h-full object-cover"
                          />
                        </Wrapper>
                      </div>

                      <div className="font-[HelveticaBold,Helvetica,sans] uppercase text-[15px] !mt-[10px] text-center min-h-[45px] break-words font-bold text-black">
                        {item?.fields?.title}
                      </div>
                    </div>
                  </SwiperSlide>
                )
              )
            })}
          </Swiper>
        </div>

        {/* Grid */}
        {shoppingGuideImageData?.cards && (
          <div className="hidden md:grid grid-cols-1 md:grid-cols-3 gap-x-[20px] gap-y-[40px]">
            {shoppingGuideImageData?.cards?.map((item, i) => {
              const Wrapper = item?.fields?.linkUrl ? "a" : "div"
              return (
                item?.fields?.imageUrl && (
                  <div key={i} className="space-y-3 aspect-[4/3]">
                    <div className="overflow-hidden bg-gray-100">
                      <Wrapper
                        className={` block ${
                          item?.fields?.linkUrl
                            ? "cursor-pointer"
                            : "cursor-default"
                        }`}
                        href={
                          item?.fields?.linkUrl
                            ? `/${locale}${item.fields.linkUrl}`
                            : undefined
                        }
                      >
                        <img
                          src={item?.fields?.imageUrl}
                          alt={item?.fields?.title || ""}
                          className="w-full h-full object-cover"
                        />
                      </Wrapper>
                    </div>

                    <div className="font-[HelveticaBold,Helvetica,sans] uppercase text-[15px] !mt-[10px] text-center min-h-[45px] break-word font-bold text-black">
                      {item?.fields?.title || ""}
                    </div>
                  </div>
                )
              )
            })}
          </div>
        )}

        {/* <hr class="border-gray-300 my-4" /> */}
        {horizontalRule && (
          <hr className="mx-auto border-0 h-[2px] bg-[#d6d6d6] md:my-5" />
        )}
      </div>
    </div>
  )
}

export default ShoppingGuideImage
